module.exports = __webpack_public_path__ + "img/logoEstado.db4e65cd.svg";